import React, { useContext, useState } from "react";
import { Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { BsCart3, BsHeart, BsHeartFill } from "react-icons/bs";
import "../../../assets/css/customer/components/SingleProduct.css";
import AppContext from "../../../contexts/AppContext";

const SingleProduct = ({ product, onAddToCart, onAddToWishlist }) => {
  const { baseUrlForFiles, setSelectedProductForCustomer } =
    useContext(AppContext);
  const [isHovered, setIsHovered] = useState(false);
  const [isWishlisted, setIsWishlisted] = useState(false);
  const navigate = useNavigate();

  const isOutOfStock = Number(product.stock_quantity) <= 0;

  // Safe fallback: agar images array missing ya empty ho to placeholder use karo
  const hasImage = product?.images && product.images.length > 0;
  const imageSrc = hasImage
    ? `${baseUrlForFiles}/${product.images[0].image_path}`
    : "/placeholder-image.png"; // apni public folder mein ek placeholder image rakh lena

  const handleAddToCart = (e) => {
    e.stopPropagation();
    if (isOutOfStock) return;
    if (onAddToCart) {
      onAddToCart(product.id);
    }
  };

  const handleAddToWishlist = (e) => {
    e.stopPropagation();
    setIsWishlisted(!isWishlisted);
    if (onAddToWishlist) {
      onAddToWishlist(product.id);
    }
  };

  const handleCardClick = () => {
    const priceValue =
      typeof product.price === "string"
        ? parseFloat(product.price.replace(/[$Rs]/g, "").trim())
        : product.price;
    console.log("Full product object:", product);
    setSelectedProductForCustomer(product);
    navigate("/product");
  };

  return (
    <Card
      className={`product-card border-0 ${isOutOfStock ? "out-of-stock" : ""}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={handleCardClick}
    >
      {/* Badge - Out of Stock ko priority, warna normal badge */}
      {isOutOfStock ? (
        <span className="product-badge out-of-stock">Out of Stock</span>
      ) : (
        product.badge && (
          <span className={`product-badge ${product.badge.toLowerCase()}`}>
            {product.badge}
          </span>
        )
      )}

      {/* Product Image */}
      <div
        className={`product-image-wrapper ${
          isOutOfStock ? "is-out-of-stock" : ""
        }`}
      >
        <Card.Img
          src={imageSrc}
          alt={product.product_name}
          className="product-image"
        />
        <div className="image-overlay"></div>
      </div>

      {/* Product Info */}
      <Card.Body className="product-info">
        <Card.Title as="h3" className="product-name">
          {product.product_name}
        </Card.Title>
        <Card.Text as="p" className="product-price">
          Rs{" "}
          {typeof product.price === "string"
            ? product.price.replace(/[$]/g, "")
            : product.price}
        </Card.Text>
      </Card.Body>

      {/* Product Actions - Hover Effect */}
      <div className={`product-actions ${isHovered ? "active" : ""}`}>
        <button
          className="btn-add-to-cart"
          onClick={handleAddToCart}
          aria-label="Add to cart"
          disabled={isOutOfStock}
        >
          <BsCart3 size={18} />
          <span>{isOutOfStock ? "Unavailable" : "Add to Cart"}</span>
        </button>
        <button
          className="btn-wishlist"
          onClick={handleAddToWishlist}
          aria-label="Add to wishlist"
        >
          {isWishlisted ? <BsHeartFill size={18} /> : <BsHeart size={18} />}
        </button>
      </div>

      {/* Decorative Corner */}
      <div className="card-corner"></div>
    </Card>
  );
};

export default SingleProduct;